import React from 'react';

const webcam = () => {
    
return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><g id="webcam"><path d="M21,23A7,7,0,0,0,21,9H11a7,7,0,0,0,0,14h.85l-.72,5H10a1,1,0,0,0,0,2H22a1,1,0,0,0,0-2H20.87l-.72-5ZM6,16a5,5,0,0,1,5-5H21a5,5,0,0,1,0,10H11A5,5,0,0,1,6,16ZM18.85,28h-5.7l.72-5h4.26Z"/><path d="M16,7a1,1,0,0,0,1-1V3a1,1,0,0,0-2,0V6A1,1,0,0,0,16,7Z"/><path d="M20.88,8a1,1,0,0,0,.71-.29l2.12-2.12a1,1,0,1,0-1.42-1.42L20.17,6.29a1,1,0,0,0,0,1.42A1,1,0,0,0,20.88,8Z"/><path d="M10.41,7.71a1,1,0,0,0,.71.29,1,1,0,0,0,.71-.29,1,1,0,0,0,0-1.42L9.71,4.17A1,1,0,0,0,8.29,5.59Z"/><path d="M16,20a4,4,0,1,0-4-4A4,4,0,0,0,16,20Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,16,14Z"/></g></svg>
)
}

export default webcam;